const VEHICLE_DATA_STORAGE_KEY = "hsCorseVehicleDataDraft";

const DEFAULT_HS_VEHICLE_DATA = {
  brands: {
    abarth: { label: "Abarth" },
    alfa_romeo: { label: "Alfa Romeo" }
  },
  models: {
    abarth_500_595_695: {
      label: "Abarth 500 / 595 / 695",
      brandId: "abarth",
      brand: "Abarth",
      engineIds: ["abarth_ihi_135", "abarth_ihi_140", "abarth_ihi_145", "abarth_ihi_160", "abarth_gt1446_165", "abarth_gt1446_180"],
      transmissionIds: ["manual", "mta"],
      modelDescription: "Voor Abarth 500, 595 en 695 uitvoeringen."
    },
    abarth_punto_evo: {
      label: "Abarth Punto EVO",
      brandId: "abarth",
      brand: "Abarth",
      engineIds: ["abarth_punto_multiair_163", "abarth_punto_multiair_180"],
      transmissionIds: ["manual"],
      modelDescription: "Voor Abarth Punto EVO MultiAir 163 en 180 pk uitvoeringen."
    },
    grande_punto_abarth: {
      label: "Grande Punto Abarth",
      brandId: "abarth",
      brand: "Abarth",
      engineIds: ["grande_punto_abarth_tjet_155", "grande_punto_abarth_tjet_180"],
      transmissionIds: ["manual"],
      modelDescription: "Voor Grande Punto Abarth T-Jet uitvoeringen."
    },
    abarth_124_spider: {
      label: "Abarth 124",
      brandId: "abarth",
      brand: "Abarth",
      engineIds: ["abarth_124_multiair_170"],
      transmissionIds: ["manual", "automatic"],
      modelDescription: "Voor Abarth 124 1.4 MultiAir."
    },
    alfa_giulia: {
      label: "Alfa Giulia",
      brandId: "alfa_romeo",
      brand: "Alfa Romeo",
      engineIds: ["alfa_giulia_20t_200", "alfa_giulia_20t_280", "alfa_giulia_20t_280_opf"],
      transmissionIds: ["zf8"],
      modelDescription: "Voor Alfa Giulia 2.0T uitvoeringen."
    },
    alfa_stelvio: {
      label: "Alfa Stelvio",
      brandId: "alfa_romeo",
      brand: "Alfa Romeo",
      engineIds: ["alfa_stelvio_20t_200", "alfa_stelvio_20t_280", "alfa_stelvio_20t_280_opf"],
      transmissionIds: ["zf8"],
      modelDescription: "Voor Alfa Stelvio 2.0T uitvoeringen."
    },
    alfa_giulietta: {
      label: "Alfa Giulietta",
      brandId: "alfa_romeo",
      brand: "Alfa Romeo",
      engineIds: ["alfa_giulietta_tjet_120_euro5", "alfa_giulietta_tjet_120_euro6", "alfa_giulietta_multiair_170_euro5", "alfa_giulietta_multiair_150_euro6", "alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"],
      transmissionIds: ["manual", "tct"],
      modelDescription: "Voor Giulietta 1.4 T-Jet, 1.4 MultiAir en 1750 TBi uitvoeringen."
    },
    alfa_mito: {
      label: "Alfa MiTo",
      brandId: "alfa_romeo",
      brand: "Alfa Romeo",
      engineIds: ["alfa_mito_tjet_120", "alfa_mito_tjet_150", "alfa_mito_multiair_135", "alfa_mito_qv_multiair_170_euro5", "alfa_mito_qv_multiair_170_euro6"],
      transmissionIds: ["manual"],
      modelDescription: "Voor Alfa MiTo T-Jet en MultiAir uitvoeringen."
    },
  },
  engines: {
    abarth_ihi_135: { label: "1.4 T-Jet IHI - 135 pk", family: "abarth_ihi", originalPower: "135 pk", originalTorque: "206 Nm", pricingVehicleId: "abarth595", pricingVariantId: "euro5" },
    abarth_ihi_140: { label: "1.4 T-Jet IHI - 140 pk", family: "abarth_ihi", originalPower: "140 pk", originalTorque: "206 Nm", pricingVehicleId: "abarth595", pricingVariantId: "euro5" },
    abarth_ihi_145: { label: "1.4 T-Jet IHI - 145 pk", family: "abarth_ihi", originalPower: "145 pk", originalTorque: "206 Nm", pricingVehicleId: "abarth595", pricingVariantId: "euro5" },
    abarth_ihi_160: { label: "1.4 T-Jet IHI - 160 pk", family: "abarth_ihi", originalPower: "160 pk", originalTorque: "230 Nm", pricingVehicleId: "abarth595", pricingVariantId: "euro6" },
    abarth_gt1446_165: { label: "1.4 T-Jet GT1446 - 165 pk", family: "abarth_gt1446", originalPower: "165 pk", originalTorque: "230 Nm", pricingVehicleId: "abarth595", pricingVariantId: "euro6" },
    abarth_gt1446_180: { label: "1.4 T-Jet GT1446 - 180 pk", family: "abarth_gt1446", originalPower: "180 pk", originalTorque: "250 Nm", pricingVehicleId: "abarth595", pricingVariantId: "euro6" },
    abarth_punto_multiair_163: { label: "1.4 MultiAir 163 pk", family: "multiair_gt1446", technology: "multiair", originalPower: "163 pk", originalTorque: "250 Nm", pricingVehicleId: "abarthPuntoEvo", pricingVariantId: "multiair163" },
    abarth_punto_multiair_180: { label: "1.4 MultiAir 180 pk", family: "multiair_gt1446", technology: "multiair", originalPower: "180 pk", originalTorque: "270 Nm", pricingVehicleId: "abarthPuntoEvo", pricingVariantId: "multiair180" },
    grande_punto_abarth_tjet_155: { label: "1.4 T-Jet 155 pk", family: "grande_punto_abarth_tjet_155", originalPower: "155 pk", originalTorque: "230 Nm", pricingVehicleId: "grandePuntoAbarth", pricingVariantId: "tjet155" },
    grande_punto_abarth_tjet_180: { label: "1.4 T-Jet 180 pk", family: "grande_punto_abarth_tjet_180", originalPower: "180 pk", originalTorque: "270 Nm", pricingVehicleId: "grandePuntoAbarth", pricingVariantId: "tjet180" },
    abarth_124_multiair_140: { label: "1.4 MultiAir 140 pk", family: "abarth_124_multiair_140", technology: "multiair", originalPower: "140 pk", originalTorque: "240 Nm", pricingVehicleId: "abarth124Spider", pricingVariantId: "multiair140" },
    abarth_124_multiair_170: { label: "1.4 MultiAir 170 pk", family: "abarth_124_multiair_170", technology: "multiair", originalPower: "170 pk", originalTorque: "250 Nm", pricingVehicleId: "abarth124Spider", pricingVariantId: "multiair170" },
    alfa_mito_tjet_120: { label: "1.4 T-Jet 120 pk", family: "alfa_mito_tjet_120", originalPower: "120 pk", originalTorque: "206 Nm", pricingVehicleId: "alfaMito", pricingVariantId: "tjet120", description: "MiTo Euro 5: 2008-2013. Euro 6: 2014-heden." },
    alfa_mito_tjet_150: { label: "1.4 T-Jet 150 pk", family: "alfa_mito_tjet_150", originalPower: "150 pk", originalTorque: "230 Nm", pricingVehicleId: "alfaMito", pricingVariantId: "tjet150", description: "MiTo Euro 5: 2008-2013. Euro 6: 2014-heden." },
    alfa_mito_multiair_135: { label: "1.4 MultiAir - 135 pk", family: "alfa_mito_multiair_135", technology: "multiair", originalPower: "135 pk", originalTorque: "230 Nm", pricingVehicleId: "alfaMito", pricingVariantId: "multiair135", description: "MiTo Euro 5: 2008-2013. Euro 6: 2014-heden." },
    alfa_mito_qv_multiair_170_euro5: { label: "1.4 MultiAir QV 170 pk Euro 5 (2008-2013)", family: "multiair_gt1446", technology: "multiair", originalPower: "170 pk", originalTorque: "250 Nm", pricingVehicleId: "alfaMito", pricingVariantId: "multiair170Euro5" },
    alfa_mito_qv_multiair_170_euro6: { label: "1.4 MultiAir QV 170 pk Euro 6 (2014-heden)", family: "multiair_gt1446", technology: "multiair", originalPower: "170 pk", originalTorque: "250 Nm", pricingVehicleId: "alfaMito", pricingVariantId: "multiair170Euro6" },
    alfa_giulietta_tjet_120_euro5: { label: "1.4 T-Jet 120 pk Euro 5 (2010-2013)", family: "alfa_giulietta_tjet_120", originalPower: "120 pk", originalTorque: "206 Nm", pricingVehicleId: "alfaGiulietta", pricingVariantId: "tjet120Euro5" },
    alfa_giulietta_tjet_120_euro6: { label: "1.4 T-Jet 120 pk Euro 6 (2014-heden)", family: "alfa_giulietta_tjet_120", originalPower: "120 pk", originalTorque: "206 Nm", pricingVehicleId: "alfaGiulietta", pricingVariantId: "tjet120Euro6" },
    alfa_giulietta_multiair_150_euro6: { label: "1.4 MultiAir 150 pk Euro 6 (2014-heden)", family: "multiair_gt1446", technology: "multiair", originalPower: "150 pk", originalTorque: "250 Nm", pricingVehicleId: "alfaGiulietta", pricingVariantId: "multiair14Euro6" },
    alfa_giulietta_multiair_170_euro5: { label: "1.4 MultiAir 170 pk Euro 5 (2010-2013)", family: "multiair_gt1446", technology: "multiair", originalPower: "170 pk", originalTorque: "250 Nm", pricingVehicleId: "alfaGiulietta", pricingVariantId: "multiair14Euro5" },
    alfa_giulietta_1750_tbi_manual: { label: "1750 TBi / QV 235 pk handgeschakeld", family: "alfa_giulietta_1750_tbi_manual", originalPower: "235 pk", originalTorque: "340 Nm", pricingVehicleId: "alfaGiulietta", pricingVariantId: "qvTbiEuro5" },
    alfa_giulietta_1750_tbi_tct: { label: "1750 TBi / QV 241 pk TCT", family: "alfa_giulietta_1750_tbi_tct", originalPower: "241 pk", originalTorque: "340 Nm", pricingVehicleId: "alfaGiulietta", pricingVariantId: "qvTbiTctEuro6" },
    alfa_giulia_20t_200: { label: "2.0T 200 PK", family: "alfa_giulia_20t_200", originalPower: "200 pk", originalTorque: "330 Nm", pricingVehicleId: "alfaGiulia", pricingVariantId: "hp200" },
    alfa_giulia_20t_280: { label: "2.0T 280 PK", family: "alfa_giulia_20t_280", originalPower: "280 pk", originalTorque: "400 Nm", pricingVehicleId: "alfaGiulia", pricingVariantId: "hp280" },
    alfa_giulia_20t_280_opf: { label: "2.0T 280 PK EU6D OPF", family: "alfa_giulia_20t_280_opf", originalPower: "280 pk", originalTorque: "400 Nm", pricingVehicleId: "alfaGiulia", pricingVariantId: "hp280Opf" },
    alfa_stelvio_20t_200: { label: "2.0T 200 PK", family: "alfa_stelvio_20t_200", originalPower: "200 pk", originalTorque: "330 Nm", pricingVehicleId: "alfaStelvio", pricingVariantId: "hp200" },
    alfa_stelvio_20t_280: { label: "2.0T 280 PK", family: "alfa_stelvio_20t_280", originalPower: "280 pk", originalTorque: "400 Nm", pricingVehicleId: "alfaStelvio", pricingVariantId: "hp280" },
    alfa_stelvio_20t_280_opf: { label: "2.0T 280 PK EU6D OPF", family: "alfa_stelvio_20t_280_opf", originalPower: "280 pk", originalTorque: "400 Nm", pricingVehicleId: "alfaStelvio", pricingVariantId: "hp280Opf" },
    unknown: { label: "Weet ik niet", family: "unknown", originalPower: "Te bepalen", originalTorque: "Te bepalen" }
  },
  goals: {
    stage_1: { label: "Stage 1", type: "stage" },
    stage_2: { label: "Stage 2", type: "stage" },
    stage_2_plus: { label: "Stage 2+", type: "stage" },
    stage_3: { label: "Stage 3", type: "stage" },
    stage_3_plus: { label: "Stage 3+", type: "stage" },
    stage_4: { label: "Stage 4", type: "project" },
    advice: { label: "Advies nodig", type: "advice" }
  },
  extraOptions: {
    noExtraOptions: { label: "Geen extra opties", priceId: null },
    popsAndBangs: {
      label: "Pops & Bangs in alle standen",
      priceId: "popsAndBangs",
      description: "In hardheid en duratie te programmeren."
    },
    popsAndBangsDynamic: {
      label: "Pops & Bangs in Dynamic",
      priceId: "popsAndBangs",
      availableFromStage: "stage_1",
      category: "software",
      description: "Alleen actief wanneer de rijmodus Dynamic is ingeschakeld."
    },
    mtaTuning: {
      label: "MTA tuning",
      priceId: "mtaTuning",
      category: "software",
      description: "Versnellingsbaksoftware voor de MTA, alleen toevoegen wanneer dit gewenst is.",
      requiresTransmission: "mta"
    },
    popsAndBangsAbarthEuro6SportButton: {
      label: "Pops & Bangs enkel onder sport",
      priceId: "popsAndBangsAbarthEuro6SportButton",
      availableFromStage: "stage_1",
      category: "software",
      description: "Enkel actief onder de sportknop.\nIn hardheid en duratie te programmeren.",
      requiresEmissionStandard: "euro6"
    },
    startStopDisable: {
      label: "Start stop uitschakelen",
      priceId: "startStopDisable",
      excludedModelIds: ["abarth_500_595_695", "abarth_punto_evo", "grande_punto_abarth", "abarth_124_spider"],
      excludedEngineIds: ["alfa_giulietta_1750_tbi", "alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"]
    }
  },
  parts: {
    intake: { label: "Intake kit" },
    sport_filter: { label: "Sport inleg filter" },
    downpipe_200: {
      label: "200 cells sportkat",
      requiredLabel: "Sportdownpipe: open of met 200-cells sportkat",
      availableFromStage: "stage_2"
    },
    open_downpipe: { label: "Open sportdownpipe", availableFromStage: "stage_2" },
    full_exhaust_635: {
      label: "Front-back 63,5mm",
      excludedModelIds: ["alfa_giulia", "alfa_stelvio", "abarth_124_spider"]
    },
    full_exhaust_70: {
      label: "Front-back 70mm",
      modelIds: ["abarth_124_spider"]
    },
    full_exhaust_76: {
      label: "Volledig 76mm (3 inch) front-to-back uitlaat",
      modelIds: ["alfa_giulia", "alfa_stelvio"],
      availableFromStage: "stage_2"
    },
    midpipe_76: {
      label: "76mm tussenbuis",
      modelIds: ["alfa_giulia", "alfa_stelvio"],
      availableFromStage: "stage_2"
    },
    alfa_sport_muffler: {
      label: "Sport einddemper (o.a. Ragazzon)",
      modelIds: ["alfa_giulia", "alfa_stelvio"],
      availableFromStage: "stage_2"
    },
    midpipe_635: {
      label: "63,5 mm tussenbuis",
      excludedModelIds: ["alfa_giulia", "alfa_stelvio", "abarth_124_spider"]
    },
    midpipe_70: {
      label: "70 mm tussenbuis",
      modelIds: ["abarth_124_spider"]
    },
    abarth_124_sport_muffler: {
      label: "Sport einddemper",
      modelIds: ["abarth_124_spider"]
    },
    stage2_midpipe_635: {
      label: "Stage 2 tussenbuis (van 63,5mm naar originele maat)",
      modelIds: ["abarth_500_595_695"],
      maxStage: "stage_2"
    },
    turismo_muffler: {
      label: "Ik heb een Turismo einddemper",
      modelIds: ["abarth_500_595_695"]
    },
    sport_muffler: {
      label: "Ik heb een Ragazzon / door H&S Corse aangepaste Akra",
      requiredLabel: "Sporteinddemper: Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter",
      stageLabels: {
        stage_1: "Ik heb een Ragazzon / door H&S Corse aangepaste Akra",
        stage_2: "Ik heb een Ragazzon / door H&S Corse aangepaste Akra",
        stage_2_plus: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic",
        stage_3: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic",
        stage_3_plus: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic",
        stage_4: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic"
      },
      requiredLabels: {
        stage_2: "Sporteinddemper: Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter",
        stage_2_plus: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic",
        stage_3: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic",
        stage_3_plus: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic",
        stage_4: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic"
      },
      modelIds: ["abarth_500_595_695"]
    },
    intercooler: {
      label: "Front Mount intercooler",
      excludedModelIds: ["alfa_giulia", "alfa_stelvio"]
    },
    standard_intercooler: {
      label: "Standaard intercooler",
      excludedModelIds: ["alfa_giulia", "alfa_stelvio"]
    },
    injectors_390cc: { label: "390cc / 613cc injectoren", availableFromStage: "stage_2_plus" },
    hybrid_turbo: {
      label: "GT1446 Hybrid",
      availableFromStage: "stage_2_plus"
    },
    gt1446_upgrade: {
      label: "GT1446 upgrade",
      modelIds: ["abarth_500_595_695"],
      engineFamilies: ["abarth_ihi"],
      availableFromStage: "stage_2_plus"
    },
    alfa_hybrid_turbo: {
      label: "Hybride turbo met toebehoren",
      modelIds: ["alfa_giulia", "alfa_stelvio"],
      availableFromStage: "stage_2_plus"
    },
    k04_hybrid_stage1: {
      label: "K04 Hybrid Stage 1 turbo",
      engineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"],
      availableFromStage: "stage_3"
    },
    k04_hybrid_stage2: {
      label: "K04 Hybrid Stage 2 turbo",
      engineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"],
      availableFromStage: "stage_3"
    },
    k04_hybrid_turbo: { label: "K04 Hybrid Stage 1 of Stage 2 turbo", hidden: true },
    td04_turbo: {
      label: "TD04 turbo",
      availableFromStage: "stage_3",
      excludedEngineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"]
    },
    gbc_turbo: {
      label: "GBC turbo",
      availableFromStage: "stage_3",
      excludedEngineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"]
    },
    td04_gbc_turbo: { label: "TD04 turbo of GBC turbo", hidden: true },
    bov_adapter: { label: "BOV-adapter", availableFromStage: "stage_3", engineTechnology: "multiair" },
    stock: { label: "Auto is technisch nog helemaal fabrieks standaard." }
  },
  requiredParts: {
    abarth_gt1446_stage_2: ["downpipe_200", "intercooler", "intake"],
    multiair_gt1446_stage_2: ["downpipe_200", "full_exhaust_635", "intercooler", "intake"],
    alfa_1750_stage_2: ["downpipe_200", "full_exhaust_635", "intercooler", "intake"],
    abarth_124_stage_2: ["downpipe_200", "intercooler", "intake"],
    alfa_giulia_stelvio_stage_2: ["downpipe_200", "intake"],
    alfa_giulia_stelvio_stage_2_plus: ["alfa_hybrid_turbo", "downpipe_200", "intake"],
    alfa_1750_stage_3: ["k04_hybrid_turbo", "intercooler", "full_exhaust_635", "downpipe_200", "intake", "injectors_390cc"],
    stage_2_plus: ["hybrid_turbo", "intercooler", "intake", "full_exhaust_635", "injectors_390cc", "downpipe_200"],
    abarth_stage_3: ["td04_gbc_turbo", "intercooler", "full_exhaust_635", "downpipe_200", "intake", "injectors_390cc"]
  },
  stageRequirements: {
    abarth_gt1446_stage_2_exhaust: {
      label: "Uitlaat: volledig 63,5 mm front-to-back of een 63,5 mm tussenbuis met geschikte sporteinddemper",
      fullSystemPartId: "full_exhaust_635",
      midpipePartId: "midpipe_635",
      alternativeMidpipePartIds: ["stage2_midpipe_635"],
      sportMufflerPartId: "sport_muffler"
    },
    alfa_giulia_stelvio_76mm_exhaust: {
      label: "Uitlaat: volledig 76mm (3 inch) front-to-back of een 76mm tussenbuis met sporteinddemper",
      fullSystemPartId: "full_exhaust_76",
      midpipePartId: "midpipe_76",
      sportMufflerPartId: "alfa_sport_muffler"
    },
    abarth_124_70mm_exhaust: {
      label: "Uitlaat: front-back 70mm of 70mm tussenbuis",
      fullSystemPartId: "full_exhaust_70",
      midpipePartId: "midpipe_70"
    }
  },
  performanceProfiles: {
    abarth_stage_2_plus_hybrid: {
      power: "265-280 pk",
      torque: "350-370 Nm",
      description: "Het uiteindelijke resultaat varieert tussen 265 en 280 pk en 350 tot 370 Nm, afhankelijk van het gekozen type hybride turbo.",
      familyIds: ["abarth_gt1446", "multiair_gt1446"]
    }
  },
  results: {
    abarth_ihi: {
      stage_1: { stage: "Stage 1", power: "170-180 pk", torque: "295-315 Nm", priceId: "stage_1" },
      stage_2_plus: { stage: "Stage 2+ GT1446 upgrade", power: "215-220 pk", torque: "350-360 Nm", requiredPartsId: "stage_2_plus", priceId: "stage_2_plus" }
    },
    abarth_gt1446: {
      stage_1: { stage: "Stage 1", power: "200-205 pk", torque: "335 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "215-220 pk", torque: "350-360 Nm", requiredPartsId: "abarth_gt1446_stage_2", priceId: "stage_2" }
    },
    multiair_gt1446: {
      stage_1: { stage: "Stage 1", power: "200-205 pk", torque: "335 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "215-220 pk", torque: "350-360 Nm", requiredPartsId: "multiair_gt1446_stage_2", priceId: "stage_2" }
    },
    abarth_124_multiair_140: {
      stage_1: { stage: "Stage 1", power: "+20 pk", torque: "+50 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "+30 pk", torque: "+70 Nm", requiredPartsId: "abarth_124_stage_2", priceId: "stage_2" }
    },
    abarth_124_multiair_170: {
      stage_1: { stage: "Stage 1", power: "+20 pk", torque: "+50 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "+30 pk", torque: "+70 Nm", requiredPartsId: "abarth_124_stage_2", priceId: "stage_2" }
    },
    alfa_mito_multiair_135: {
      stage_1: { stage: "Stage 1", power: "155 pk", torque: "300 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "165 pk", torque: "320 Nm", priceId: "stage_2", warningIds: ["mitoStage2"] }
    },
    alfa_giulietta_multiair_170: {
      stage_1: { stage: "Stage 1", power: "200 pk", torque: "300 Nm", priceId: "stage_1" }
    },
    alfa_giulietta_1750_tbi: {
      stage_1: { stage: "Stage 1", power: "285 pk", torque: "385 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "305 pk", torque: "395 Nm", requiredPartsId: "alfa_1750_stage_2", priceId: "stage_2" }
    },
    alfa_giulia_20t_200: {
      stage_1: { stage: "Stage 1", power: "280 pk", torque: "420 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "300+ pk", torque: "450+ Nm", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    },
    alfa_giulia_20t_280: {
      stage_1: { stage: "Stage 1", power: "300 pk", torque: "450 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "320+ pk", torque: "470+ Nm", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    },
    alfa_stelvio_20t_200: {
      stage_1: { stage: "Stage 1", power: "280 pk", torque: "420 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "300+ pk", torque: "450+ Nm", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    },
    alfa_stelvio_20t_280: {
      stage_1: { stage: "Stage 1", power: "300 pk", torque: "450 Nm", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "320+ pk", torque: "470+ Nm", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    }
  },
  warnings: {
    ihiStage2:
      "Met de originele IHI turbo is dit vermogen niet haalbaar. Wij adviseren een GT1446 turbo-upgrade voor een veel groter en betrouwbaarder resultaat.",
    stage3:
      "Stage 3 projecten voeren wij uitsluitend uit op voertuigen die volledig bij ons worden opgebouwd met onze eigen onderdelen. Alleen zo kunnen wij de werking, betrouwbaarheid en afstelling goed controleren.",
    mitoStage2:
      "Een Stage 2 op deze motor maakt ten opzichte van Stage 1 geen hele grote stap. Als je echt meer winst wilt, adviseren wij om te kijken naar een GT1446 turbo-upgrade.",
    popsOriginalExhaust:
      "Voor Pops & Bangs en het uiteindelijke geluidsresultaat is een geschikt sportuitlaatsysteem belangrijk. Wij adviseren minimaal een Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter.",
    popsTurismoLimited:
      "Met een standaard Turismo-einddemper zijn Pops & Bangs mogelijk, maar het uiteindelijke geluidseffect is beperkt. Voor een beter resultaat adviseren wij minimaal een Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter.",
    popsTurismoLimitedHigherStage:
      "Met een standaard Turismo-einddemper zijn Pops & Bangs mogelijk, maar het uiteindelijke geluidseffect is beperkt. Kies een sporteinddemper die geschikt is voor de gekozen stage.",
    turismoStage2:
      "Voor Stage 2 moet de Turismo-einddemper worden vervangen door een Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter.",
    turismoStage2Plus:
      "Voor Stage 2+, Stage 3 en hogere projecten is alleen een Ragazzon of een door H&S Corse aangepaste Akrapovic geschikt.",
    technical:
      "Op basis van je antwoorden adviseren wij eerst een technische controle of onderhoud voordat we tuning uitvoeren. Tuning is alleen verantwoord wanneer de auto technisch in goede staat is.",
    incompleteTurboSetup:
      "Deze samenstelling werkt niet veilig en correct.\nEen TD04, GBC of GT1446 Hybrid turbo vereist altijd minimaal een volledig front-to-back uitlaatsysteem, een open of 200-cells sportdownpipe, een intake kit, een front mount intercooler en 390cc of 613cc injectoren.\nEen of meerdere onderdelen hiervan ontbreekt in jouw samengestelde setup."
    ,
    stage2MidpipeTooHigh:
      "De Stage 2 tussenbuis is alleen geschikt voor Stage 1 en Stage 2. Vanaf Stage 2+ is deze setup niet geschikt en adviseren wij een volledig passend 63,5 mm uitlaatsysteem."
  },
  adviceText: {
    reliableStage:
      "Op basis van jouw keuzes adviseren wij {stage}. Dit is voor jouw setup de meest logische en betrouwbare upgrade.",
    corrected:
      "Je gekozen wens past niet goed bij deze setup. Daarom adviseren wij de route die technisch beter klopt voor jouw auto.",
    technicalHold:
      "We adviseren om eerst de technische staat van de auto te controleren voordat er tuning wordt uitgevoerd.",
    custom:
      "Voor deze combinatie geven wij liever persoonlijk maatwerkadvies. Zo kunnen we de auto en de gewenste setup goed beoordelen.",
    project:
      "Stage 3 en hoger behandelen wij als volledige H&S Corse opbouw. Dat is de juiste route wanneer betrouwbaarheid, onderdelen en afstelling samen moeten kloppen.",
    sound:
      "Pops & Bangs kan alleen goed worden beoordeeld in combinatie met de juiste uitlaatsetup."
  }
};

function loadVehicleDataDraft() {
  try {
    if (typeof window === "undefined" || !window.localStorage) {
      return null;
    }

    return JSON.parse(window.localStorage.getItem(VEHICLE_DATA_STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

function normalizeVehicleData(data) {
  const normalized = mergeVehicleDataDefaults(DEFAULT_HS_VEHICLE_DATA, data);

  delete normalized.brands.fiat;
  Object.entries(normalized.models).forEach(([modelId, model]) => {
    if (model.brandId === "fiat") {
      delete normalized.models[modelId];
    }
  });

  if (normalized.models.abarth_punto_evo) {
    normalized.models.abarth_punto_evo.label = "Abarth Punto EVO";
    normalized.models.abarth_punto_evo.engineIds = ["abarth_punto_multiair_163", "abarth_punto_multiair_180"];
    normalized.models.abarth_punto_evo.modelDescription = "Voor Abarth Punto EVO MultiAir 163 en 180 pk uitvoeringen.";
  }

  normalized.engines.abarth_punto_multiair_163 = {
    label: "1.4 MultiAir 163 pk",
    family: "multiair_gt1446",
    technology: "multiair",
    originalPower: "163 pk",
    originalTorque: "250 Nm",
    pricingVehicleId: "abarthPuntoEvo",
    pricingVariantId: "multiair163"
  };
  normalized.engines.abarth_punto_multiair_180 = {
    label: "1.4 MultiAir 180 pk",
    family: "multiair_gt1446",
    technology: "multiair",
    originalPower: "180 pk",
    originalTorque: "270 Nm",
    pricingVehicleId: "abarthPuntoEvo",
    pricingVariantId: "multiair180"
  };

  delete normalized.engines.abarth_punto_multiair_170;
  delete normalized.engines.abarth_punto_tjet_155_180;

  normalized.engines.grande_punto_abarth_tjet_155 = {
    label: "1.4 T-Jet 155 pk",
    family: "grande_punto_abarth_tjet_155",
    originalPower: "155 pk",
    originalTorque: "230 Nm",
    pricingVehicleId: "grandePuntoAbarth",
    pricingVariantId: "tjet155"
  };
  normalized.engines.grande_punto_abarth_tjet_180 = {
    label: "1.4 T-Jet 180 pk",
    family: "grande_punto_abarth_tjet_180",
    originalPower: "180 pk",
    originalTorque: "270 Nm",
    pricingVehicleId: "grandePuntoAbarth",
    pricingVariantId: "tjet180"
  };
  delete normalized.engines.grande_punto_abarth_tjet_155_180;

  normalized.models.grande_punto_abarth = {
    label: "Grande Punto Abarth",
    brandId: "abarth",
    brand: "Abarth",
    engineIds: ["grande_punto_abarth_tjet_155", "grande_punto_abarth_tjet_180"],
    transmissionIds: ["manual"],
    modelDescription: "Voor Grande Punto Abarth T-Jet uitvoeringen."
  };

  if (normalized.models.abarth_124_spider) {
    normalized.models.abarth_124_spider.label = "Abarth 124";
    normalized.models.abarth_124_spider.engineIds = ["abarth_124_multiair_170"];
    normalized.models.abarth_124_spider.transmissionIds = ["manual", "automatic"];
    normalized.models.abarth_124_spider.modelDescription = "Voor Abarth 124 1.4 MultiAir.";
  }

  if (normalized.engines.abarth_124_multiair_170) {
    normalized.engines.abarth_124_multiair_170.technology = "multiair";
  }

  normalized.models.alfa_mito.engineIds = [
    "alfa_mito_tjet_120",
    "alfa_mito_tjet_150",
    "alfa_mito_multiair_135",
    "alfa_mito_qv_multiair_170_euro5",
    "alfa_mito_qv_multiair_170_euro6"
  ];
  normalized.models.alfa_mito.modelDescription = "Voor Alfa MiTo T-Jet, MultiAir en QV-uitvoeringen.";
  normalized.engines.alfa_mito_tjet_120 = {
    label: "1.4 T-Jet 120 pk",
    family: "alfa_mito_tjet_120",
    originalPower: "120 pk",
    originalTorque: "206 Nm",
    pricingVehicleId: "alfaMito",
    pricingVariantId: "tjet120",
    description: "MiTo Euro 5: 2008-2013. Euro 6: 2014-heden."
  };
  normalized.engines.alfa_mito_tjet_150 = {
    label: "1.4 T-Jet 150 pk",
    family: "alfa_mito_tjet_150",
    originalPower: "150 pk",
    originalTorque: "230 Nm",
    pricingVehicleId: "alfaMito",
    pricingVariantId: "tjet150",
    description: "MiTo Euro 5: 2008-2013. Euro 6: 2014-heden."
  };
  delete normalized.engines.alfa_mito_tjet_120_155;
  if (normalized.engines.alfa_mito_multiair_135) {
    normalized.engines.alfa_mito_multiair_135.technology = "multiair";
    normalized.engines.alfa_mito_multiair_135.pricingVariantId = "multiair135";
    normalized.engines.alfa_mito_multiair_135.description = "MiTo Euro 5: 2008-2013. Euro 6: 2014-heden.";
  }
  normalized.engines.alfa_mito_qv_multiair_170_euro5 = {
    label: "1.4 MultiAir QV 170 pk Euro 5 (2008-2013)",
    family: "multiair_gt1446",
    technology: "multiair",
    originalPower: "170 pk",
    originalTorque: "250 Nm",
    pricingVehicleId: "alfaMito",
    pricingVariantId: "multiair170Euro5"
  };
  normalized.engines.alfa_mito_qv_multiair_170_euro6 = {
    label: "1.4 MultiAir QV 170 pk Euro 6 (2014-heden)",
    family: "multiair_gt1446",
    technology: "multiair",
    originalPower: "170 pk",
    originalTorque: "250 Nm",
    pricingVehicleId: "alfaMito",
    pricingVariantId: "multiair170Euro6"
  };

  normalized.models.alfa_giulietta.engineIds = [
    "alfa_giulietta_tjet_120_euro5",
    "alfa_giulietta_tjet_120_euro6",
    "alfa_giulietta_multiair_170_euro5",
    "alfa_giulietta_multiair_150_euro6",
    "alfa_giulietta_1750_tbi_manual",
    "alfa_giulietta_1750_tbi_tct"
  ];
  normalized.models.alfa_giulietta.modelDescription = "Voor Giulietta 1.4 T-Jet, 1.4 MultiAir en 1750 TBi uitvoeringen.";
  normalized.engines.alfa_giulietta_tjet_120_euro5 = {
    label: "1.4 T-Jet 120 pk Euro 5 (2010-2013)",
    family: "alfa_giulietta_tjet_120",
    originalPower: "120 pk",
    originalTorque: "206 Nm",
    pricingVehicleId: "alfaGiulietta",
    pricingVariantId: "tjet120Euro5"
  };
  normalized.engines.alfa_giulietta_tjet_120_euro6 = {
    label: "1.4 T-Jet 120 pk Euro 6 (2014-heden)",
    family: "alfa_giulietta_tjet_120",
    originalPower: "120 pk",
    originalTorque: "206 Nm",
    pricingVehicleId: "alfaGiulietta",
    pricingVariantId: "tjet120Euro6"
  };
  normalized.engines.alfa_giulietta_multiair_150_euro6 = {
    label: "1.4 MultiAir 150 pk Euro 6 (2014-heden)",
    family: "multiair_gt1446",
    technology: "multiair",
    originalPower: "150 pk",
    originalTorque: "250 Nm",
    pricingVehicleId: "alfaGiulietta",
    pricingVariantId: "multiair14Euro6"
  };
  if (normalized.engines.alfa_giulietta_multiair_170_euro5) {
    normalized.engines.alfa_giulietta_multiair_170_euro5.label = "1.4 MultiAir 170 pk Euro 5 (2010-2013)";
    normalized.engines.alfa_giulietta_multiair_170_euro5.family = "multiair_gt1446";
    normalized.engines.alfa_giulietta_multiair_170_euro5.technology = "multiair";
  }
  normalized.engines.alfa_giulietta_1750_tbi_manual = {
    label: "1750 TBi / QV 235 pk handgeschakeld",
    family: "alfa_giulietta_1750_tbi_manual",
    originalPower: "235 pk",
    originalTorque: "340 Nm",
    pricingVehicleId: "alfaGiulietta",
    pricingVariantId: "qvTbiEuro5"
  };
  normalized.engines.alfa_giulietta_1750_tbi_tct = {
    label: "1750 TBi / QV 241 pk TCT",
    family: "alfa_giulietta_1750_tbi_tct",
    originalPower: "241 pk",
    originalTorque: "340 Nm",
    pricingVehicleId: "alfaGiulietta",
    pricingVariantId: "qvTbiTctEuro6"
  };
  delete normalized.engines.alfa_giulietta_1750_tbi;
  delete normalized.engines.alfa_giulietta_multiair_170_euro6;

  ["alfa_giulia", "alfa_stelvio"].forEach((modelId) => {
    if (!normalized.models[modelId]) return;
    delete normalized.models[modelId].engineQuestion;
    const prefix = modelId === "alfa_giulia" ? "alfa_giulia" : "alfa_stelvio";
    normalized.models[modelId].engineIds = [`${prefix}_20t_200`, `${prefix}_20t_280`, `${prefix}_20t_280_opf`];
  });
  normalized.engines.alfa_giulia_20t_280_opf = {
    label: "2.0T 280 PK EU6D OPF",
    family: "alfa_giulia_20t_280_opf",
    originalPower: "280 pk",
    originalTorque: "400 Nm",
    pricingVehicleId: "alfaGiulia",
    pricingVariantId: "hp280Opf"
  };
  normalized.engines.alfa_stelvio_20t_280_opf = {
    label: "2.0T 280 PK EU6D OPF",
    family: "alfa_stelvio_20t_280_opf",
    originalPower: "280 pk",
    originalTorque: "400 Nm",
    pricingVehicleId: "alfaStelvio",
    pricingVariantId: "hp280Opf"
  };

  if (normalized.extraOptions.popsAndBangsAbarthEuro6SportButton) {
    normalized.extraOptions.popsAndBangsAbarthEuro6SportButton.label = "Pops & Bangs enkel onder sport";
    normalized.extraOptions.popsAndBangsAbarthEuro6SportButton.availableFromStage = "stage_1";
    normalized.extraOptions.popsAndBangsAbarthEuro6SportButton.category = "software";
    normalized.extraOptions.popsAndBangsAbarthEuro6SportButton.description =
      "Enkel actief onder de sportknop.\nIn hardheid en duratie te programmeren.";
    normalized.extraOptions.popsAndBangsAbarthEuro6SportButton.requiresEmissionStandard = "euro6";
  }

  if (normalized.extraOptions.popsAndBangs) {
    normalized.extraOptions.popsAndBangs.label = "Pops & Bangs in alle standen";
    normalized.extraOptions.popsAndBangs.description = "In hardheid en duratie te programmeren.";
  }
  normalized.extraOptions.popsAndBangsDynamic = {
    label: "Pops & Bangs in Dynamic",
    priceId: "popsAndBangs",
    availableFromStage: "stage_1",
    category: "software",
    description: "Alleen actief wanneer de rijmodus Dynamic is ingeschakeld."
  };
  normalized.extraOptions.mtaTuning = {
    label: "MTA tuning",
    priceId: "mtaTuning",
    category: "software",
    description: "Versnellingsbaksoftware voor de MTA, alleen toevoegen wanneer dit gewenst is.",
    requiresTransmission: "mta"
  };
  normalized.extraOptions.startStopDisable = {
    label: "Start stop uitschakelen",
    priceId: "startStopDisable",
    excludedModelIds: ["abarth_500_595_695", "abarth_punto_evo", "grande_punto_abarth", "abarth_124_spider"],
    excludedEngineIds: ["alfa_giulietta_1750_tbi", "alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"]
  };

  if (normalized.parts.hybrid_turbo) {
    normalized.parts.hybrid_turbo.label = "GT1446 Hybrid";
    normalized.parts.hybrid_turbo.availableFromStage = "stage_2_plus";
  }
  normalized.parts.gt1446_upgrade = {
    label: "GT1446 upgrade",
    modelIds: ["abarth_500_595_695"],
    engineFamilies: ["abarth_ihi"],
    availableFromStage: "stage_2_plus"
  };

  normalized.parts.downpipe_200 = {
    label: "200 cells sportkat",
    requiredLabel: "Sportdownpipe: open of met 200-cells sportkat",
    availableFromStage: "stage_2"
  };
  normalized.parts.open_downpipe = { label: "Open sportdownpipe", availableFromStage: "stage_2" };
  normalized.parts.full_exhaust_635.label = "Front-back 63,5mm";
  normalized.parts.full_exhaust_635.excludedModelIds = ["alfa_giulia", "alfa_stelvio", "abarth_124_spider"];
  normalized.parts.full_exhaust_70 = {
    label: "Front-back 70mm",
    modelIds: ["abarth_124_spider"]
  };
  normalized.parts.full_exhaust_76 = {
    label: "Volledig 76mm (3 inch) front-to-back uitlaat",
    modelIds: ["alfa_giulia", "alfa_stelvio"],
    availableFromStage: "stage_2"
  };
  normalized.parts.midpipe_76 = {
    label: "76mm tussenbuis",
    modelIds: ["alfa_giulia", "alfa_stelvio"],
    availableFromStage: "stage_2"
  };
  normalized.parts.alfa_sport_muffler = {
    label: "Sport einddemper (o.a. Ragazzon)",
    modelIds: ["alfa_giulia", "alfa_stelvio"],
    availableFromStage: "stage_2"
  };
  normalized.parts.midpipe_635 = {
    label: "63,5 mm tussenbuis",
    excludedModelIds: ["alfa_giulia", "alfa_stelvio", "abarth_124_spider"]
  };
  normalized.parts.midpipe_70 = {
    label: "70 mm tussenbuis",
    modelIds: ["abarth_124_spider"]
  };
  normalized.parts.abarth_124_sport_muffler = {
    label: "Sport einddemper",
    modelIds: ["abarth_124_spider"]
  };
  normalized.parts.stage2_midpipe_635 = {
    label: "Stage 2 tussenbuis (van 63,5mm naar originele maat)",
    modelIds: ["abarth_500_595_695"],
    maxStage: "stage_2"
  };
  normalized.parts.turismo_muffler = {
    label: "Ik heb een Turismo einddemper",
    modelIds: ["abarth_500_595_695"]
  };
  normalized.parts.sport_muffler = {
    label: "Ik heb een Ragazzon / door H&S Corse aangepaste Akra",
    requiredLabel: "Sporteinddemper: Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter",
    stageLabels: {
      stage_1: "Ik heb een Ragazzon / door H&S Corse aangepaste Akra",
      stage_2: "Ik heb een Ragazzon / door H&S Corse aangepaste Akra",
      stage_2_plus: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic",
      stage_3: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic",
      stage_3_plus: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic",
      stage_4: "Ik heb een Ragazzon of een door H&S Corse aangepaste Akrapovic"
    },
    requiredLabels: {
      stage_2: "Sporteinddemper: Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter",
      stage_2_plus: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic",
      stage_3: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic",
      stage_3_plus: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic",
      stage_4: "Sporteinddemper: Ragazzon of een door H&S Corse aangepaste Akrapovic"
    },
    modelIds: ["abarth_500_595_695"]
  };
  normalized.parts.intercooler.excludedModelIds = ["alfa_giulia", "alfa_stelvio"];
  normalized.parts.standard_intercooler = {
    label: "Standaard intercooler",
    excludedModelIds: ["alfa_giulia", "alfa_stelvio"]
  };
  normalized.parts.injectors_390cc = {
    label: "390cc / 613cc injectoren",
    availableFromStage: "stage_2_plus",
    excludedModelIds: ["alfa_giulia", "alfa_stelvio"]
  };
  normalized.parts.alfa_hybrid_turbo = {
    label: "Hybride turbo met toebehoren",
    modelIds: ["alfa_giulia", "alfa_stelvio"],
    availableFromStage: "stage_2_plus"
  };
  normalized.parts.k04_hybrid_stage1 = {
    label: "K04 Hybrid Stage 1 turbo",
    engineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"],
    availableFromStage: "stage_3"
  };
  normalized.parts.k04_hybrid_stage2 = {
    label: "K04 Hybrid Stage 2 turbo",
    engineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"],
    availableFromStage: "stage_3"
  };
  normalized.parts.k04_hybrid_turbo = { label: "K04 Hybrid Stage 1 of Stage 2 turbo", hidden: true };
  normalized.parts.td04_turbo = {
    label: "TD04 turbo",
    availableFromStage: "stage_3",
    excludedEngineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"]
  };
  normalized.parts.gbc_turbo = {
    label: "GBC turbo",
    availableFromStage: "stage_3",
    excludedEngineFamilies: ["alfa_giulietta_1750_tbi_manual", "alfa_giulietta_1750_tbi_tct"]
  };
  normalized.parts.td04_gbc_turbo = { label: "TD04 turbo of GBC turbo", hidden: true };
  normalized.parts.bov_adapter = { label: "BOV-adapter", availableFromStage: "stage_3", engineTechnology: "multiair" };
  normalized.parts.stock = { label: "Auto is technisch nog helemaal fabrieks standaard." };
  normalized.requiredParts.abarth_gt1446_stage_2 = ["downpipe_200", "intercooler", "intake"];
  normalized.requiredParts.multiair_gt1446_stage_2 = ["downpipe_200", "full_exhaust_635", "intercooler", "intake"];
  normalized.requiredParts.abarth_124_stage_2 = ["downpipe_200", "intercooler", "intake"];
  normalized.requiredParts.alfa_giulia_stelvio_stage_2 = ["downpipe_200", "intake"];
  normalized.requiredParts.alfa_giulia_stelvio_stage_2_plus = ["alfa_hybrid_turbo", "downpipe_200", "intake"];
  normalized.requiredParts.alfa_1750_stage_3 = ["k04_hybrid_turbo", "intercooler", "full_exhaust_635", "downpipe_200", "intake", "injectors_390cc"];
  normalized.requiredParts.stage_2_plus = ["hybrid_turbo", "intercooler", "intake", "full_exhaust_635", "injectors_390cc", "downpipe_200"];
  normalized.requiredParts.abarth_stage_3 = ["td04_gbc_turbo", "intercooler", "full_exhaust_635", "downpipe_200", "intake", "injectors_390cc"];
  normalized.stageRequirements = normalized.stageRequirements || {};
  normalized.stageRequirements.abarth_gt1446_stage_2_exhaust = {
    label: "Uitlaat: volledig 63,5 mm front-to-back of een 63,5 mm tussenbuis met geschikte sporteinddemper",
    fullSystemPartId: "full_exhaust_635",
    midpipePartId: "midpipe_635",
    alternativeMidpipePartIds: ["stage2_midpipe_635"],
    sportMufflerPartId: "sport_muffler"
  };
  normalized.stageRequirements.alfa_giulia_stelvio_76mm_exhaust = {
    label: "Uitlaat: volledig 76mm (3 inch) front-to-back of een 76mm tussenbuis met sporteinddemper",
    fullSystemPartId: "full_exhaust_76",
    midpipePartId: "midpipe_76",
    sportMufflerPartId: "alfa_sport_muffler"
  };
  normalized.stageRequirements.abarth_124_70mm_exhaust = {
    label: "Uitlaat: front-back 70mm of 70mm tussenbuis",
    fullSystemPartId: "full_exhaust_70",
    midpipePartId: "midpipe_70"
  };
  normalized.performanceProfiles = normalized.performanceProfiles || {};
  normalized.performanceProfiles.abarth_stage_2_plus_hybrid = {
    power: "265-280 pk",
    torque: "350-370 Nm",
    description: "Het uiteindelijke resultaat varieert tussen 265 en 280 pk en 350 tot 370 Nm, afhankelijk van het gekozen type hybride turbo.",
    familyIds: ["abarth_gt1446", "multiair_gt1446"]
  };
  normalized.results.multiair_gt1446 = {
    stage_1: { stage: "Stage 1", power: "200-205 pk", torque: "335 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "215-220 pk", torque: "350-360 Nm", requiredPartsId: "multiair_gt1446_stage_2", priceId: "stage_2" }
  };
  normalized.results.abarth_124_multiair_140 = {
    stage_1: { stage: "Stage 1", power: "+20 pk", torque: "+50 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "+30 pk", torque: "+70 Nm", requiredPartsId: "abarth_124_stage_2", priceId: "stage_2" }
  };
  normalized.results.abarth_124_multiair_170 = {
    stage_1: { stage: "Stage 1", power: "+20 pk", torque: "+50 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "+30 pk", torque: "+70 Nm", requiredPartsId: "abarth_124_stage_2", priceId: "stage_2" }
  };
  normalized.results.alfa_mito_tjet_120 = {
    stage_1: { stage: "Stage 1", power: "145 pk", torque: "260 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "155 pk", torque: "280 Nm", priceId: "stage_2" }
  };
  normalized.results.alfa_mito_tjet_150 = {
    stage_1: { stage: "Stage 1", power: "175 pk", torque: "290 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "185 pk", torque: "310 Nm", priceId: "stage_2" }
  };
  normalized.results.grande_punto_abarth_tjet_155 = {
    stage_1: { stage: "Stage 1", power: "180-185 pk", torque: "300 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "195-205 pk", torque: "320 Nm", priceId: "stage_2" }
  };
  normalized.results.grande_punto_abarth_tjet_180 = {
    stage_1: { stage: "Stage 1", power: "200-205 pk", torque: "335 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "215-220 pk", torque: "350-360 Nm", requiredPartsId: "multiair_gt1446_stage_2", priceId: "stage_2" }
  };
  normalized.results.alfa_giulietta_1750_tbi_manual = {
    stage_1: { stage: "Stage 1", power: "285 pk", torque: "385 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "305 pk", torque: "395 Nm", requiredPartsId: "alfa_1750_stage_2", priceId: "stage_2" }
  };
  normalized.results.alfa_giulietta_1750_tbi_tct = {
    stage_1: { stage: "Stage 1", power: "285 pk", torque: "400 Nm", priceId: "stage_1" },
    stage_2: { stage: "Stage 2", power: "305 pk", torque: "410 Nm", requiredPartsId: "alfa_1750_stage_2", priceId: "stage_2" }
  };
  ["alfa_giulia_20t_200", "alfa_stelvio_20t_200"].forEach((familyId) => {
    normalized.results[familyId] = {
      ...(normalized.results[familyId] || {}),
      stage_2: { stage: "Stage 2", power: "300+ pk", torque: "450+ Nm", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    };
  });
  ["alfa_giulia_20t_280", "alfa_stelvio_20t_280"].forEach((familyId) => {
    normalized.results[familyId] = {
      ...(normalized.results[familyId] || {}),
      stage_2: { stage: "Stage 2", power: "320+ pk", torque: "470+ Nm", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    };
  });
  ["alfa_giulia_20t_280_opf", "alfa_stelvio_20t_280_opf"].forEach((familyId) => {
    normalized.results[familyId] = {
      ...(normalized.results[familyId] || {}),
      stage_1: { stage: "Stage 1", power: "OPF-afhankelijk", torque: "OPF-afhankelijk", priceId: "stage_1" },
      stage_2: { stage: "Stage 2", power: "OPF-afhankelijk", torque: "OPF-afhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2", priceId: "stage_2" },
      stage_2_plus: { stage: "Stage 2+", power: "Setupafhankelijk", torque: "Setupafhankelijk", requiredPartsId: "alfa_giulia_stelvio_stage_2_plus", priceId: "stage_2_plus" }
    };
  });
  normalized.warnings.popsOriginalExhaust =
    "Voor Pops & Bangs en het uiteindelijke geluidsresultaat is een geschikt sportuitlaatsysteem belangrijk. Wij adviseren minimaal een Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter.";
  normalized.warnings.popsTurismoLimited =
    "Met een standaard Turismo-einddemper zijn Pops & Bangs mogelijk, maar het uiteindelijke geluidseffect is beperkt. Voor een beter resultaat adviseren wij minimaal een Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter.";
  normalized.warnings.popsTurismoLimitedHigherStage =
    "Met een standaard Turismo-einddemper zijn Pops & Bangs mogelijk, maar het uiteindelijke geluidseffect is beperkt. Kies een sporteinddemper die geschikt is voor de gekozen stage.";
  normalized.warnings.turismoStage2 =
    "Voor Stage 2 moet de Turismo-einddemper worden vervangen door een Bombardone, Record Monza, Akrapovic, Ragazzon of Ulter.";
  normalized.warnings.turismoStage2Plus =
    "Voor Stage 2+, Stage 3 en hogere projecten is alleen een Ragazzon of een door H&S Corse aangepaste Akrapovic geschikt.";
  normalized.warnings.incompleteTurboSetup =
    "Deze samenstelling werkt niet veilig en correct.\nEen TD04, GBC of GT1446 Hybrid turbo vereist altijd minimaal een volledig front-to-back uitlaatsysteem, een open of 200-cells sportdownpipe, een intake kit, een front mount intercooler en 390cc of 613cc injectoren.\nEen of meerdere onderdelen hiervan ontbreekt in jouw samengestelde setup.";
  normalized.warnings.stage2MidpipeTooHigh =
    "De Stage 2 tussenbuis is alleen geschikt voor Stage 1 en Stage 2. Vanaf Stage 2+ is deze setup niet geschikt en adviseren wij een volledig passend 63,5 mm uitlaatsysteem.";
  delete normalized.warnings.turismoHigherStage;

  return normalized;
}

function mergeVehicleDataDefaults(defaults, draft) {
  if (Array.isArray(defaults)) {
    return Array.isArray(draft) ? draft : structuredClone(defaults);
  }

  if (!isVehicleDataObject(defaults)) {
    return draft ?? structuredClone(defaults);
  }

  if (!isVehicleDataObject(draft)) {
    return structuredClone(defaults);
  }

  const merged = structuredClone(defaults);
  Object.entries(draft).forEach(([key, value]) => {
    merged[key] = key in defaults ? mergeVehicleDataDefaults(defaults[key], value) : value;
  });
  return merged;
}

function isVehicleDataObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

window.HS_DEFAULT_VEHICLE_DATA = normalizeVehicleData(DEFAULT_HS_VEHICLE_DATA);
window.HS_VEHICLE_DATA = normalizeVehicleData(loadVehicleDataDraft() || DEFAULT_HS_VEHICLE_DATA);
